module.exports = __webpack_public_path__ + "img/icon_auxiliar.e7a079cd.svg";